import { ReactNode, createContext, useState } from "react";
import { FileWithPreview } from "../components/Dropzone";

export interface Endereco {
    cep: string;
    rua: string;
    numero: string;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string;
}

export interface Responsavel {
    id: string;
    nome: string;
}

export interface Cadastro {
    email: string;
    password: string;
    cnpj: string;
    cnae: string;
    razaoSocial: string;
    responsavel: Responsavel;
    telefone: string;
    faturamentoDe: number | null;
    faturamentoAte: number | null;
    possuiBeneficiarios25Porcento: boolean;
    funcaoEmpresa: string;
    files: FileWithPreview[];
    endereco: Endereco;
    enderecoValidado: boolean,
    fotoRosto: string;
    fotoAssinatura: Blob | null;
    isEmpresa: boolean;
    emailValidado: boolean;
    passwordValidada: boolean;
    cnpjValidado: boolean;
    telefoneValidado: boolean;
    frenteDocumento: string;
    versoDocumento: string;
    frenteDocumentoValidado: boolean;
    versoDocumentoValidado: boolean;
    nome: string;
    sexo: string;
    data_nascimento: string | null;
    cpf: string;
    cpfValidado: boolean;
    idConsulta: string;
    dadosDoTrabalhadorVerificados: boolean;
    userId: number;
    editarCadastro: boolean;
    reaproveitamentoAso: boolean;
    primeiraVez: boolean;
};

const estadoInicial: Cadastro = {
    email: "",
    password: "",
    cnpj: "",
    cnae: "",
    razaoSocial: "",
    responsavel: {
        id: '',
        nome: ''
    },
    telefone: "",
    faturamentoDe: null,
    faturamentoAte: null,
    possuiBeneficiarios25Porcento: false,
    funcaoEmpresa: "",
    files: [],
    endereco: {
        cep: '',
        rua: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        complemento: ''
    },
    enderecoValidado: false,
    fotoRosto: "",
    fotoAssinatura: null,
    isEmpresa: false,
    emailValidado: false,
    passwordValidada: false,
    cnpjValidado: false,
    telefoneValidado: false,
    frenteDocumento: "",
    versoDocumento: "",
    frenteDocumentoValidado: false,
    versoDocumentoValidado: false,
    nome: "",
    sexo: "",
    data_nascimento: null,
    cpf: "",
    cpfValidado: false,
    idConsulta: "",
    dadosDoTrabalhadorVerificados: false,
    userId: 0,
    editarCadastro: false,
    reaproveitamentoAso: false,
    primeiraVez: false
};

interface CadastroContextType {
    cadastro: Cadastro;
    handleCadastroChange: (newEmpresa: Partial<Cadastro>) => void;
    handleCadastroClear: (cadastro: Partial<Cadastro>) => void;
}

export const CadastroContext = createContext<CadastroContextType>({
    cadastro: estadoInicial,
    handleCadastroChange: () => {},
    handleCadastroClear: () => {}
});

export const CadastroProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [cadastro, setCadastro] = useState<Cadastro>(estadoInicial);

    const handleCadastroChange = (newCadastro: Partial<Cadastro>) => {
        setCadastro((prevCadastro) => ({ ...prevCadastro, ...newCadastro }));
    };

    const handleCadastroClear = (cad: Partial<Cadastro>) => {
        setCadastro(estadoInicial);
    }

    return (
        <CadastroContext.Provider value={{ cadastro, handleCadastroChange, handleCadastroClear }}>
            { children }
        </CadastroContext.Provider>
    );
}